import React from "react"
import styled from "styled-components"
import WpContent from "../general/wpContent"
import {colors} from "../../constants/css"

function addDays(date, days) {
  date.setDate(date.getDate() + days)
  return date
}

function Events({events, isShowsVisible, setIsShowsVisible}) {
  const sortedEvents = [...events].sort((a, b) => {
    const [d1, m1, y1] = a.node.event.date.split(" ").map(Number)
    const [d2, m2, y2] = b.node.event.date.split(" ").map(Number)

    const date1 = new Date(y1, m1 - 1, d1)
    const date2 = new Date(y2, m2 - 1, d2)

    return date1 - date2 // ascending: nearest upcoming event first
  })

  return (
    <>
      <ShowsTitle isActive={isShowsVisible} onClick={() => setIsShowsVisible(!isShowsVisible)}>
        live events, shows, etc.
      </ShowsTitle>

      {isShowsVisible && (
        <Shows>
          {sortedEvents.map(({node: event}, i) => {
            let currentDate = typeof window !== "undefined" && new Date()
            let from = event.event.date.split(" ")
            let eventDate = typeof window !== "undefined" && new Date(from[2], from[1] - 1, from[0])
            let isInFuture = addDays(eventDate, 1) > currentDate
            return (
              isInFuture && (
                <Event key={i}>
                  {event.event.date && <DateSpan>{event.event.date}</DateSpan>}
                  {event.title && <h3>{event.title}</h3>}
                  {event.content && <WpContent content={event.content} />}
                </Event>
              )
            )
          })}
        </Shows>
      )}
    </>
  )
}
const Shows = styled.div`
  padding-top: 15px;
`

const ShowsTitle = styled.h3`
  text-transform: ${({isActive}) => (isActive ? "uppercase" : "none")};
  cursor: pointer;
  padding-left: 15px;
  position: relative;
  &:before {
    content: "";
    transform: rotate(${({isActive}) => (isActive ? 90 : 0)}deg);
    position: absolute;
    left: 0px;
    top: 2px;
    transition: 0.2s;
    border-top: 7px solid transparent;
    border-bottom: 7px solid transparent;
    border-left: 12px solid ${colors.white};
  }
`

const Event = styled.div`
  padding-bottom: 15px;
`

const DateSpan = styled.span`
  background-color: ${colors.red};
  padding: 2px 5px;
  margin-bottom: 4px;
  display: inline-block;
`

export default Events
